import { LittleModalCreateEdit } from '../../../../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import { FormRender } from '../../../../../../../forms/FormRenderer/types'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'
import { ModalEditComponentProps } from '../../../../../../../baseComponents/ModalsLayouts/types'
import { valueOrDefaultValue } from '../../../../../../../utils/globals/valueOrDefaultValue'
import { permissionCheck } from '../../../../../../../baseComponents/PermissionChecker/function'
import { getAllGroupVats } from '../../../../../../../utils/reducers/getters'
import { CostSellModelType } from '@teinor/erp/types/company/config/cost/costSell'

interface ModalCECostSellProps extends ModalEditComponentProps {}

const ModalCECostSell: React.FC<ModalCECostSellProps> = ({ allRowData, userPermissions, ...rest }) => {
    const groupVats = getAllGroupVats()
    const { t } = useTwinTranslation()
    const fields: FormRender<CostSellModelType> = [
        {
            cols: 1,
            elements: [
                {
                    name: 'name',
                    label: t('name', 'Nombre'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    required: true,
                },
                {
                    name: 'GroupVatId',
                    label: t('groupVat', 'Grupo de impuestos'),
                    component: 'CustomSelectWithSearchBar',
                    items: groupVats || {},
                    value: allRowData?.GroupVatId,
                    required: true,
                },
                {
                    name: 'id',
                    component: 'InputHidden'
                }
            ]
        },
    ]
    
    if (allRowData && userPermissions) {
        const parsedFields = valueOrDefaultValue(fields, userPermissions, allRowData)
        return (<LittleModalCreateEdit fields={parsedFields} url={'/api/app/config/cost/costSell/updateCostSell'} translations={{ title: t('editCostSell', 'Editar coste de presupuesto'), button: t('save', 'Guardar') }} haveButtonPermissions={permissionCheck(userPermissions, 'update')} {...rest} />)
    }
    return (<LittleModalCreateEdit fields={fields} url={'/api/app/config/cost/costSell/createCostSell'} translations={{
        title: t('createCostSell', 'Crear coste de venta'),
        button: t('create', 'Crear')
    }} haveButtonPermissions={true} {...rest} />)
}

export default ModalCECostSell